// extracted by mini-css-extract-plugin
module.exports =  {"thumbnail":"edP5XOXFezlD7Cr9FoSE"};